import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter, Route, Switch, NavLink } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history';
import { css, cx } from '@emotion/css';
import { GlobalStyles } from '@cimpress/react-components';
import DocsHeader from './DocsHeader.jsx';
import Introduction from './introduction.jsx';
import components from './pages';

const sideBar = css`
  width: 200px;
  flex: 0 0 auto;
  margin: 8px 16px;
  padding: 8px;
  background-color: white;
`;

const flex = css`
  display: flex;
`;

const minHeight = css`
  min-height: calc(100vh - 120px);
`;

const activeLink = css`
  font-weight: bold;
`;

class App extends Component {
  private history: any;

  private basename: any;

  constructor() {
    super({});
    // TODO make these act nice on previous versions
    const basename = process.env.BASE_NAME || (process.env.NODE_ENV === 'production' ? '/react-components/latest' : '');
    const ROOT_URL =
      process.env.NODE_ENV === 'production' ? `https://static.ux.cimpress.io/${basename}/` : 'http://localhost:8080/';
    this.basename = basename;
    this.history = createHistory({ basename });
    const path = window.location.hash.slice(1);
    if (path) {
      window.location.hash = '';
      this.history.replaceState({}, '', `${ROOT_URL}${path}`);
    }
  }

  render() {
    return (
      <BrowserRouter basename={this.basename}>
        <GlobalStyles />
        <DocsHeader />
        <div className={flex}>
          <div className={sideBar}>
            <div>
              <NavLink to="/" activeClassName={activeLink} exact>
                Introduction
              </NavLink>
            </div>
            <h5>Available Components:</h5>
            {components.map(component => (
              <div key={component.displayName}>
                <NavLink to={component.route} activeClassName={activeLink}>
                  {component.displayName}
                </NavLink>
              </div>
            ))}
          </div>
          <div className="container">
            <div className={cx('content-wrapper', minHeight)}>
              <Switch>
                {components.map(c => (
                  <Route key={c.route} path={c.route} component={c.component} />
                ))}
                <Route path="/(index.html)?" component={Introduction} />
              </Switch>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default hot(module)(App);
